// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"483":"9cfce612","828":"3d81d461","918":"d6cf7af7"}[chunkId] + ".css";
};